<template>
  <div
    class="viewing-time"
    :class="[
      { 'block-filled': isBlockFilled },
      { 'disable-element': !isCalc }
    ]"
  >
    <div class="block-heading">
      SET VIEWING TIME
    </div>
    <div class="time-select">
      <div class="view">
        <v-autocomplete
          v-model="customViewTime"
          :items="customViewTimeList"
          label="Viewing Time: *"
          @change="onViewTimeChange($event)"
        />
        <!-- <v-text-field
          v-else
          id="viewingTime"
          disabled
          placeholder="Viewing Time: 20 min"
        /> -->
        <!-- <v-radio-group
          id="viewingType"
          v-model="viewingType"
          row
          hide-details
          @change="viewingTypeSelector"
        >
          <v-radio label="default time" value="0" />
          <v-radio label="custom time" value="1" />
        </v-radio-group> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initialValue: {
      type: Number,
      default: null
    },
    isCalc: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    viewingType: '0',
    customViewTime: null
  }),

  computed: {
    customViewTimeList() {
      return this.getCustomViewTimeList()
    },

    isBlockFilled() {
      return (
        (this.viewingType === '0' ||
          (this.viewingType === '1' && this.customViewTime)) &&
        this.isCalc
      )
    }
  },

  watch: {
    initialValue(value) {
      this.setInitialValue(value)
    }
  },

  mounted() {
    this.setInitialValue(this.initialValue)
  },

  methods: {
    setInitialValue(value) {
      if (value) {
        this.viewingType = '1'
        this.customViewTime = value
      }
    },

    getCustomViewTimeList() {
      let timeArray = []
      for (let i = 5; i < 50; i = i + 5) {
        timeArray.push({ text: `${i} min`, value: i })
      }
      return timeArray
    },

    onViewTimeChange(value) {
      this.$emit('on-change', value)
    },

    viewingTypeSelector(event) {
      if (event === '1') {
        this.onViewTimeChange(null)
      } else {
        this.customViewTime = null
        this.onViewTimeChange(20)
      }
    }
  }
}
</script>

<style lang="sass">
.time-select .v-input--selection-controls
  margin-top: 0 !important
  margin-bottom: 2rem !important
  label
    font-size: 1.4rem

.view input
  text-align: center !important
</style>

<style lang="sass" scoped>
.viewing-time
  grid-area: viewing
  border: 1px solid $hwayzce
  padding: calc(10% / 3) 5% 0
  text-align: center

.time-select
  display: grid
  grid-template-areas: ". view ."
  grid-template-columns: 1fr 2fr 1fr
  grid-column-gap: 5%
  align-items: center
  .view
    grid-area: view

#viewingTime
  width: 100%
  padding: 8px 0
  text-align: center
  line-height: 20px
  font-size: 16px
  margin-bottom: 2rem
  border-bottom: 1px solid $hwayzShadow
</style>
